import { render, staticRenderFns } from "./myworkdetail.vue?vue&type=template&id=a5bcb17c"
import script from "./myworkdetail.vue?vue&type=script&lang=js"
export * from "./myworkdetail.vue?vue&type=script&lang=js"
import style0 from "./myworkdetail.vue?vue&type=style&index=0&id=a5bcb17c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports